module.exports = __webpack_public_path__ + "img/zhang.9f378441.png";